import http from './axios'

// 获取菜单目录
export const getCatalogs = data => http('/official-website/web/catalogs', data, 'get')

// // 获取文章列表
// export const getDocs = (data) => http('/docs', data, 'get')
// 获取文章列表
export const getDocs = (catid, data) => http('/official-website/web/docs/' + catid, data, 'get')

// 根据Docid获取文章内容
export const getDocByDocid = (docid, data) => http('/official-website/web/doc/' + docid, data, 'get')

// 新建文章
export const postDoc = data => http('/newdoc', data, 'post')

// 修改文章
export const putDoc = (docid, data) => http('/doc/' + docid, data, 'put')

// 删除文章
export const deleteDoc = (docid, data) => http('/doc/' + docid, data, 'delete')

// 获取企业大事件
export const getEnterpriseEvents = (data) => http('/official-website/web/epevents', data, 'get')
